module.exports = __webpack_public_path__ + "images/emoji/kissing_cat.62e91f794608015a98a2.png";